import autenticacao from './autenticacaoRepository'
import configuracao from './configuracaoRepository'
import papel from './papelRepository'
import permissao from './permissaoRepository'
import relatorioHistoricoPapelLotacao from './relatorioHistoricoPapelLotacaoRepository'
import relatorioHistoricoPermissaoLotacao from './relatorioHistoricoPermissaoLotacaoRepository'
import relatorioHistoricoPermissaoPapel from './relatorioHistoricoPermissaoPapelRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/administracao`

    return {
        autenticacao: autenticacao(baseUrl),
        configuracao: configuracao(baseUrl),
        papel: papel(baseUrl),
        permissao: permissao(baseUrl),
        relatorioHistoricoPapelLotacao: relatorioHistoricoPapelLotacao(baseUrl),
        relatorioHistoricoPermissaoLotacao: relatorioHistoricoPermissaoLotacao(baseUrl),
        relatorioHistoricoPermissaoPapel: relatorioHistoricoPermissaoPapel(baseUrl),
    }
}
